import React from "react";
import { HomeSectionLink } from "../../shared/homeSectionNav";

function HeroSection() {
  return (
    <section className="hero-section bg-[url('../../images/banner.png')] bg-cover bg-center relative aspect-[19/7] flex items-center !pt-[100px]">
      <div className="banner-content relative z-[2] w-full !pt-[30px] py-[50px]">
        <div className="container">
          <div className="banner-content-inner text-center max-w-[950px] mx-auto flex flex-col gap-[15px]">
            <h1 className="web-h1 text-white">
              Your journey. Your questions. Your AstroAdi.
            </h1>
            <p className="web-body-lg text-white !leading-[1.6] max-w-[728px] mx-auto">
              Explore astrology, spiritual wisdom and holistic wellness — all
              in one place.
            </p>
            <p className="web-body-md text-white !leading-[1.6] max-w-[728px] mx-auto">
              From personalised astrological insights and tarot readings to
              spiritual guidance, wellness experiences and traditional
              remedies, AstroAdi brings together different paths to help you
              explore what matters to you.
            </p>
            <div className="banner-content-inner-button">
              <HomeSectionLink
                to="/download-app"
                className="custom-btn custom-btn-primary no-underline"
              >
                Get Started
              </HomeSectionLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
